import React from 'react';
import { comTracking, isIOS, isMobile } from '@helpers/EnvHelper';
import i18n, { t } from 'i18next';

{
  /* 모바일 GNB도 같이 씁니다! 작업수정시 확인해줏세요 */
}
const MainStoreBtn = () => {
  return (
    <div className="flex  gap-5 justify-center">
      {(!isMobile() || (isMobile() && !isIOS())) && (
        <a
          href={t('AOS_LINK')}
          onClick={() => comTracking('Lead', t('twttr_track_aos'))}
          target="_blank"
          rel="noreferrer"
          className="p-4 w-full bg-black rounded-[3px] border-solid border border-[#919191] inline-flex items-center min-h-[54px]"
        >
          <img
            src={`/img/v2/store/google-${
              ['kr', 'en', 'jp'].includes(i18n.language) ? i18n.language : 'kr'
            }.png`}
            alt="app"
            className="xs:w-[66%] lg:w-[50%] m-auto !h-auto "
          />
        </a>
      )}
      {(!isMobile() || (isMobile() && isIOS())) && (
        <a
          href={t('iOS_LINK')}
          onClick={() => comTracking('Lead', t('twttr_track_ios'))}
          target="_blank"
          rel="noreferrer"
          className="p-4 w-full bg-black rounded-[3px] border-solid border border-[#919191] inline-flex items-center"
        >
          <img
            src={`/img/v2/store/appstore-${
              ['kr', 'en', 'jp'].includes(i18n.language) ? i18n.language : 'kr'
            }.png`}
            alt="app"
            className="xs:w-[66%] lg:w-[50%] m-auto !h-auto "
          />
        </a>
      )}
    </div>
  );
};

export default MainStoreBtn;
